"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderContext = exports.defaultHeaderContext = void 0;

var _react = require("react");

var _styles = require("../shared/styles");

var defaultHeaderContext = {
  navBreakpoint: _styles.breakpoint,
  inverse: false
};
exports.defaultHeaderContext = defaultHeaderContext;
var HeaderContext = /*#__PURE__*/(0, _react.createContext)(defaultHeaderContext);
exports.HeaderContext = HeaderContext;